import { Component, HostBinding, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { translateInOrderEntrySource, translateInOrderStatus } from '../in-order-helper';
import { InOrder } from 'src/models/InOrder';
@Component({
  selector: 'app-in-group-buy-order-item',
  templateUrl: './in-group-buy-order-item.component.html',
  styleUrls: ['./in-group-buy-order-item.component.scss']
})
export class InGroupBuyOrderItemComponent implements OnInit {

  @Input() order: InOrder;
  @HostBinding('class.isOdd') @Input() isOdd;
  @Output() openModal = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  handleOpenModal() {
    this.openModal.emit();
  }

  translateStatus(status: string): string {
    return translateInOrderStatus(status);
  }

  translateEntrySource(entrySource: string): string {
    return translateInOrderEntrySource(entrySource);
  }
}
